import { z } from 'zod';
import { persistedTimestampSchema } from '../shared/firestore-timestamp.schema.js';
import { currencyCodeSchema } from '../shared/shipment-primitives.schema.js';
/** États financiers persistés après les événements Stripe. */
export const paymentStatusSchema = z.enum(['pending', 'paid', 'failed', 'disputed', 'refunded']);
/**
 * État Stripe persistant d’un shipment standard. `paymentAmount` et `disputeAmount`
 * sont exprimés dans l’unité mineure renvoyée par Stripe, donc en centimes pour l’euro.
 * Les champs d’échec et de litige n’apparaissent que lorsque l’événement correspondant survient.
 */
export const paymentFlowSchema = z
    .object({
    paymentStatus: paymentStatusSchema,
    paymentDate: persistedTimestampSchema.optional(),
    paymentIntentId: z.string().min(1).optional(),
    stripeSessionId: z.string().min(1).optional(),
    chargeId: z.string().min(1).optional(),
    paidAt: persistedTimestampSchema.optional(),
    paymentAmount: z.number().finite().nonnegative().optional(),
    paymentCurrency: currencyCodeSchema.optional(),
    webhookProcessed: z.boolean().optional(),
    paymentFailureCode: z.string().optional(),
    paymentFailureMessage: z.string().optional(),
    paymentFailureType: z.string().optional(),
    paymentFailedAt: persistedTimestampSchema.optional(),
    disputeId: z.string().optional(),
    disputeReason: z.string().optional(),
    disputeStatus: z.string().optional(),
    disputeAmount: z.number().finite().nonnegative().optional(),
    disputeCurrency: currencyCodeSchema.optional(),
    disputeEvidenceDueBy: z.number().int().optional(),
    disputeCreatedAt: persistedTimestampSchema.optional(),
})
    .strict();
